import { lazy } from 'react';

import { VIEW_TYPE } from 'hb-react/shared/apps/Events/containers/Index/constants';

import { useEventViewType } from './hooks/useEventViewType';

const EventsAppSharedIndex = lazy(() => import('./pages/EventsAppSharedIndex'));
const CalendarContainer = lazy(() => import('./pages/Calendar'));

export const IndexContainer = ({ config, topic }) => {
  const { view } = useEventViewType();

  if (config.eventCalendarViewEnabled && view === VIEW_TYPE.CALENDAR) {
    return <CalendarContainer config={config} />;
  }

  return <EventsAppSharedIndex config={config} topic={topic} />;
};
